import { backendFetch } from '../../backend/backend';
import React, { useEffect, useState } from 'react';
import { Stack } from '@mui/material';
import Subtitle from '../ui/Subtitle';
import BaseLeagueTable from '../tables/BaseLeagueTable';
import ScoringStructureSection from '../tables/ScoringStructureSection';

const LeagueTable = () => {
	const [leagueTable,setLeagueTable]=useState([]);
	const [scoringStructure,setScoringStructure]=useState({structure:[],maxScoresToCount:0});
	const [fetched,setFetched]=useState(false);

	useEffect(()=>{
		async function fetchData() {
			const league=await backendFetch('league?season=active');
			setLeagueTable(league);
			const scoring=await backendFetch('scoring?season=active');
			setScoringStructure(scoring);
			setFetched(true);
		}
		fetchData();
	},[]);


	return(
		<Stack>
			<Stack spacing="0">
				<Subtitle text="League Table"/>
				{ fetched && <BaseLeagueTable leagueTable={leagueTable} /> }
			</Stack>
			{ fetched && <ScoringStructureSection scoringStructure={scoringStructure} /> }		
		</Stack>
	);
}

export default LeagueTable;


